import axios from "axios"

const API = "tendero"

const datosTienda = {
    postTenderoManual(payload){
        return axios.post(`${API}`, payload)
    },
}

export default datosTienda
